import React, { useState } from 'react';
import { TextField, InputAdornment, withStyles, makeStyles, IconButton } from '@material-ui/core';
import { primaryColor } from '../utils/colors';
import { VisibilityOutlined, VisibilityOffOutlined } from '@material-ui/icons';


const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: primaryColor,
        },
        '& .MuiInput-underline:after': {
            borderColor: primaryColor,
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: primaryColor,
            },
            '&:hover fieldset': {
                borderColor: primaryColor,
            },
            '&.Mui-focused fieldset': {
                borderColor: primaryColor,
            },
        },
    },
})(TextField);

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '30px auto 10px auto',
    },
    body: {
        margin: '10px auto',
    },
}));


const CustomPasswordField = props => {

    const styledClasses = useStyles();

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const passwordVisibility = <IconButton
        // aria-label='toggle password visibility'
        onClick={handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}
        size='small'
    >
        {showPassword ? <VisibilityOutlined fontSize='small' /> : <VisibilityOffOutlined fontSize='small' />}
    </IconButton>;

    return (
        <div>
            <CssTextField
                className={styledClasses.body}
                inputRef={props.reference}
                id={props.id}
                type={showPassword ? 'text' : 'password'}
                label={props.label}
                variant="outlined"
                autoComplete='true'
                fullWidth
                required
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            {props.children}
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end" >
                            {passwordVisibility}
                        </InputAdornment>
                    )
                }}
            />
        </div>
    );
};

export default CustomPasswordField;